const documentBody = document.documentElement;
const stickyFilters = document.querySelector('.sticky-filters');
const filtersView = document.querySelector('.rolex-filters-container');
const toggleFilters = document.querySelectorAll('.mobile-filter--close');
const mobileFilterBtns = document.querySelector('.mobile-filter--reset');
const windowWidth = window.innerWidth || documentBody.clientWidth || document.body.clientWidth;

// Filter validation cache
const filterValidationCache = {};
const parser = new DOMParser();

for (const buttonClicked of toggleFilters) {
  buttonClicked.addEventListener('click', () => {
    if (windowWidth < 1304) { 
      if (filtersView.style.display === 'block') {
        filtersView.style.display = 'none';
        filtersView.style.overflowX = 'hidden';
        stickyFilters.style.zIndex = '-9';
        stickyFilters.style.display = 'none';
        documentBody.style.overflow = 'auto';
        documentBody.style.scrollBehavior = 'smooth';
      } else {
        mobileFilterBtns.style.display = 'flex';
        filtersView.style.display = 'block';
        filtersView.style.width = '100%';
        stickyFilters.style.zIndex = '999999';
        stickyFilters.style.display = 'block';
        stickyFilters.style.overflowY = 'scroll';
        stickyFilters.style.overflowX = 'hidden';
        documentBody.style.overflow = 'hidden';
        documentBody.style.scrollBehavior = 'unset';
      }
    }
  });
}

/* Set the sticky filters button position based on dynamic theme site header height */
const setStickyFilterPosition = () => {
  const elements = document.querySelectorAll('.get-header-height');
  let themeStickyHeader = 0;

  elements.forEach(element => {
    themeStickyHeader += element.offsetHeight;
  });

  document.documentElement.style.setProperty('--rolex-header-height', themeStickyHeader + 'px');
};

setStickyFilterPosition();
window.addEventListener('resize', setStickyFilterPosition);

/* Scroll snap */
document.querySelectorAll('.rolex-accordion-item a').forEach(link => {
  if (!link.href.includes('#')) {
    link.href += '#view-results';
  }
});

/* Create filter validation loader overlay - sidebar only */
const createFilterLoader = () => {
  const loader = document.createElement('div');
  loader.id = 'rolex-filter-loader';
  loader.style.cssText = `
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.85);
    display: none;
    align-items: center;
    justify-content: center;
    z-index: 5000;
    border-radius: 4px;
  `;
  
  const spinner = document.createElement('div');
  spinner.style.cssText = `
    width: 32px;
    height: 32px;
    border: 3px solid #f3f3f3;
    border-top: 3px solid #127749;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  `;
  
  loader.appendChild(spinner);
  
  // Add animation keyframes if not already present
  if (!document.querySelector('style#filter-loader-styles')) {
    const style = document.createElement('style');
    style.id = 'filter-loader-styles';
    style.textContent = `
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
      .rolex-filters-container {
        position: relative;
      }
    `;
    document.head.appendChild(style);
  }
  
  return loader;
};

const filterLoader = createFilterLoader();

/**
 * Show loader on filters panel only
 */
const showFilterLoader = () => {
  const filtersContainer = document.querySelector('.rolex-filters-container');
  if (!filtersContainer) return;

  // Ensure container has position relative for absolute positioning
  filtersContainer.style.position = 'relative';
  
  if (!filtersContainer.querySelector('#rolex-filter-loader')) {
    filtersContainer.appendChild(filterLoader);
  }
  
  filterLoader.style.display = 'flex';
};

/**
 * Hide loader from filters panel
 */
const hideFilterLoader = () => {
  filterLoader.style.display = 'none';
};

/* Accordion display */
document.addEventListener('DOMContentLoaded', () => {
  const rlx_filters = document.querySelector('.rolex-filters');

  const initializeIcons = () => {
    const accordions = document.querySelectorAll('.rolex-accordion-toggle');
    accordions.forEach((accordionHeading) => {
      const icon = accordionHeading.querySelector('.rolex-accordion-icon');
      const accordion = accordionHeading.nextElementSibling;

      if (accordion.classList.contains('open')) {
        icon.textContent = '-';
      } else {
        icon.textContent = '+';
      }
    });
  };

  initializeIcons();

  rlx_filters.addEventListener('click', (event) => {
    const accordionHeading = event.target.closest('.rolex-accordion-toggle');
    
    if (accordionHeading) {
      const accordion = accordionHeading.nextElementSibling;
      const icon = accordionHeading.querySelector('.rolex-accordion-icon');
      const isOpen = accordion.classList.contains('open');
      
      icon.textContent = isOpen ? '+' : '-';
      accordion.classList.toggle('open', !isOpen);
    }
  });

  /* ========================================
     FILTER VALIDATION 
     ======================================== */

  /**
   * Disable a filter option by hiding it completely
   */
  const disableFilter = (link) => {
    const item = link.closest('.rolex-accordion-item');
    if (!item || item.hasAttribute('data-filter-disabled')) return;

    item.style.display = 'none';
    item.setAttribute('data-filter-disabled', 'true');
  };

  /**
   * Enable a filter option by showing it
   */
  const enableFilter = (link) => {
    const item = link.closest('.rolex-accordion-item');
    if (!item) return;

    item.style.display = '';
    item.removeAttribute('data-filter-disabled');
  };

  /**
   * Fetch and validate a single filter with timeout
   */
  const validateSingleFilter = async (link) => {
    const href = link.getAttribute('href');
    if (!href || !href.includes('/collections/')) return;

    const testUrl = href.split('#')[0];

    // Check cache first
    if (filterValidationCache[testUrl] !== undefined) {
      if (filterValidationCache[testUrl] === 0) {
        disableFilter(link);
      } else {
        enableFilter(link);
      }
      return;
    }

    try {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 3000); // 3 second timeout per request

      const response = await fetch(testUrl, {
        credentials: 'same-origin',
        signal: controller.signal
      });

      clearTimeout(timeout);

      if (response.ok) {
        const html = await response.text();
        const doc = parser.parseFromString(html, 'text/html');

        const products = doc.querySelectorAll('.productLink');
        const productCount = products.length;

        filterValidationCache[testUrl] = productCount;

        if (productCount === 0) {
          disableFilter(link);
        } else {
          enableFilter(link);
        }
      }
    } catch (error) {
      console.warn('Error validating filter:', error);
    }
  };

  /**
   * Validate all filters in parallel batches for speed
   */
  const validateRemainingFilters = async () => {
    const filterLinks = Array.from(document.querySelectorAll('.rolex-accordion-item a'));
    
    if (filterLinks.length === 0) return;

    console.log(`Starting validation of ${filterLinks.length} filters...`);
    showFilterLoader();

    // Process in batches of 5 parallel requests
    const batchSize = 5;
    for (let i = 0; i < filterLinks.length; i += batchSize) {
      const batch = filterLinks.slice(i, i + batchSize);
      await Promise.all(batch.map(link => validateSingleFilter(link)));
    }

    console.log('Filter validation complete');
    hideFilterLoader();
  };

  /**
   * Run validation on page load (checks if any pre-applied filters have invalid remaining options)
   * Works for both tag-based and metafield-based filtering
   */
  const currentPath = window.location.pathname;
  const currentSearch = window.location.search;
  
  // Validate if filters are already applied (tag-based OR metafield-based)
  if (currentPath.includes('/rolex_cpo_') || currentSearch.includes('filter.p.m.')) {
    setTimeout(validateRemainingFilters, 600);
  }

  /**
   * Re-validate when user navigates via filter (before page unloads)
   */
  document.querySelectorAll('.rolex-accordion-item a').forEach(link => {
    link.addEventListener('click', () => {
      // Schedule validation after new page loads
      window.addEventListener('load', () => {
        setTimeout(validateRemainingFilters, 300);
      }, { once: true });
    });
  });
});
